export const SUPERADMIN = 1;
export const ADMIN = 2;
export const TENANTS = 3;
export const PROPERTYOWNER = 4; 
export const MANAGER = 5; 
export const TEAMLEADER = 6;
export const EMPLOYEE = 7;
export const VENDOR = 8;
